// Utility: Detectar referencias bíblicas en texto plano y generar links a YouVersion.
// Soporta los 66 libros en español (con y sin acentos), 1/2/3 + nombre, abreviaturas comunes.

// Mapeo nombre normalizado → código USFM (3 letras). Las claves NO llevan acentos.
const BOOK_USFM = {
  // Antiguo Testamento
  'genesis': 'GEN', 'gen': 'GEN',
  'exodo': 'EXO', 'ex': 'EXO',
  'levitico': 'LEV', 'lev': 'LEV',
  'numeros': 'NUM', 'num': 'NUM',
  'deuteronomio': 'DEU', 'deut': 'DEU', 'dt': 'DEU',
  'josue': 'JOS', 'jos': 'JOS',
  'jueces': 'JDG', 'jue': 'JDG',
  'rut': 'RUT', 'rt': 'RUT',
  '1samuel': '1SA', '1sam': '1SA', '1s': '1SA',
  '2samuel': '2SA', '2sam': '2SA', '2s': '2SA',
  '1reyes': '1KI', '1re': '1KI', '1r': '1KI',
  '2reyes': '2KI', '2re': '2KI', '2r': '2KI',
  '1cronicas': '1CH', '1cro': '1CH', '1cr': '1CH',
  '2cronicas': '2CH', '2cro': '2CH', '2cr': '2CH',
  'esdras': 'EZR', 'esd': 'EZR',
  'nehemias': 'NEH', 'neh': 'NEH',
  'ester': 'EST', 'est': 'EST',
  'job': 'JOB',
  'salmos': 'PSA', 'salmo': 'PSA', 'sal': 'PSA', 'sl': 'PSA',
  'proverbios': 'PRO', 'prov': 'PRO', 'pr': 'PRO',
  'eclesiastes': 'ECC', 'ecl': 'ECC',
  'cantares': 'SNG', 'cant': 'SNG', 'cnt': 'SNG',
  'isaias': 'ISA', 'isa': 'ISA', 'is': 'ISA',
  'jeremias': 'JER', 'jer': 'JER',
  'lamentaciones': 'LAM', 'lam': 'LAM',
  'ezequiel': 'EZK', 'eze': 'EZK', 'ez': 'EZK',
  'daniel': 'DAN', 'dan': 'DAN', 'dn': 'DAN',
  'oseas': 'HOS', 'os': 'HOS',
  'joel': 'JOL', 'jl': 'JOL',
  'amos': 'AMO', 'am': 'AMO',
  'abdias': 'OBA', 'abd': 'OBA',
  'jonas': 'JON', 'jon': 'JON',
  'miqueas': 'MIC', 'miq': 'MIC',
  'nahum': 'NAM', 'nah': 'NAM',
  'habacuc': 'HAB', 'hab': 'HAB',
  'sofonias': 'ZEP', 'sof': 'ZEP',
  'hageo': 'HAG', 'hag': 'HAG',
  'zacarias': 'ZEC', 'zac': 'ZEC',
  'malaquias': 'MAL', 'mal': 'MAL',
  // Nuevo Testamento
  'mateo': 'MAT', 'mt': 'MAT',
  'marcos': 'MRK', 'mar': 'MRK', 'mc': 'MRK',
  'lucas': 'LUK', 'luc': 'LUK', 'lc': 'LUK',
  'juan': 'JHN', 'jn': 'JHN',
  'hechos': 'ACT', 'hch': 'ACT',
  'romanos': 'ROM', 'rom': 'ROM', 'ro': 'ROM',
  '1corintios': '1CO', '1cor': '1CO', '1co': '1CO',
  '2corintios': '2CO', '2cor': '2CO', '2co': '2CO',
  'galatas': 'GAL', 'gal': 'GAL', 'ga': 'GAL',
  'efesios': 'EPH', 'efe': 'EPH', 'ef': 'EPH',
  'filipenses': 'PHP', 'fil': 'PHP', 'flp': 'PHP',
  'colosenses': 'COL', 'col': 'COL',
  '1tesalonicenses': '1TH', '1tes': '1TH', '1ts': '1TH',
  '2tesalonicenses': '2TH', '2tes': '2TH', '2ts': '2TH',
  '1timoteo': '1TI', '1tim': '1TI', '1ti': '1TI',
  '2timoteo': '2TI', '2tim': '2TI', '2ti': '2TI',
  'tito': 'TIT', 'tit': 'TIT',
  'filemon': 'PHM', 'flm': 'PHM',
  'hebreos': 'HEB', 'heb': 'HEB',
  'santiago': 'JAS', 'stg': 'JAS', 'sant': 'JAS',
  '1pedro': '1PE', '1ped': '1PE', '1pe': '1PE', '1p': '1PE',
  '2pedro': '2PE', '2ped': '2PE', '2pe': '2PE', '2p': '2PE',
  '1juan': '1JN', '1jn': '1JN',
  '2juan': '2JN', '2jn': '2JN',
  '3juan': '3JN', '3jn': '3JN',
  'judas': 'JUD', 'jud': 'JUD',
  'apocalipsis': 'REV', 'apoc': 'REV', 'apo': 'REV', 'ap': 'REV',
};

const normalize = (s) =>
  s.toLowerCase()
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '') // strip accents
    .replace(/\s+/g, '') // remove spaces ("1 Corintios" → "1corintios")
    .replace(/\./g, ''); // remove periods ("S. Juan" handled separately)

// Construye una alternancia de TODOS los nombres de libros conocidos (con prefijo 1/2/3
// donde aplique). Esto evita falsos positivos como "En 1" siendo capturado como libro.
// Cada vocal se expande para aceptar versión con o sin acento (Génesis = genesis).
const _expandAccents = (s) => s
  .replace(/a/g, '[aá]')
  .replace(/e/g, '[eé]')
  .replace(/i/g, '[ií]')
  .replace(/o/g, '[oó]')
  .replace(/u/g, '[uúü]')
  .replace(/n/g, '[nñ]');

const _bookNames = Object.keys(BOOK_USFM)
  .map((k) => {
    // Re-inserta espacio opcional entre dígito inicial y resto: "1corintios" → "1\\s?corintios"
    const m = /^([123])(.+)$/.exec(k);
    if (m) return `${m[1]}\\s?${_expandAccents(m[2])}`;
    return _expandAccents(k);
  })
  // sort by length desc para que "1corintios" matchee antes que "corintios"
  .sort((a, b) => b.length - a.length);
const BOOKS_ALT = _bookNames.join('|');

// Regex final: nombre del libro (case-insensitive vía flag i), opcional ".", uno o más espacios,
// capítulo, opcional :versículo o :versículo-versículo.
const REFERENCE_REGEX = new RegExp(
  `(?:^|[^\\p{L}\\p{N}])(${BOOKS_ALT})\\.?\\s+(\\d{1,3})(?::(\\d{1,3})(?:-(\\d{1,3}))?)?(?=[^\\p{L}\\p{N}]|$)`,
  'giu'
);

/**
 * Encuentra todas las referencias bíblicas en un texto.
 * @returns Array<{match, start, end, usfm, ref, book, chapter, verseStart, verseEnd}>
 */
export const findBibleReferences = (text) => {
  if (!text || typeof text !== 'string') return [];
  const results = [];
  let m;
  REFERENCE_REGEX.lastIndex = 0;
  while ((m = REFERENCE_REGEX.exec(text)) !== null) {
    const [full, bookName, chapter, verseStart, verseEnd] = m;
    const key = normalize(bookName);
    const usfmBook = BOOK_USFM[key];
    if (!usfmBook) continue; // safety guard (shouldn't happen with new regex)
    const chapterNum = parseInt(chapter, 10);
    if (!Number.isFinite(chapterNum) || chapterNum < 1 || chapterNum > 150) continue;
    let usfm = `${usfmBook}.${chapterNum}`;
    if (verseStart) {
      const vS = parseInt(verseStart, 10);
      usfm += `.${vS}`;
      if (verseEnd) usfm += `-${usfmBook}.${chapterNum}.${parseInt(verseEnd, 10)}`;
    }
    // The regex's leading "(?:^|[^\p{L}\p{N}])" may consume 1 char before the match.
    // Adjust start to point at the actual book name in the original text.
    const leadOffset = m.index === 0 ? 0 : (full.length - full.replace(/^[^\p{L}\p{N}]/u, '').length);
    const actualMatch = full.replace(/^[^\p{L}\p{N}]/u, '');
    const start = m.index + leadOffset;
    const end = start + actualMatch.length;
    results.push({
      match: actualMatch,
      start,
      end,
      usfm,
      ref: actualMatch,
      book: usfmBook,
      chapter: chapterNum,
      verseStart: verseStart ? parseInt(verseStart, 10) : null,
      verseEnd: verseEnd ? parseInt(verseEnd, 10) : null,
    });
    // Reset lastIndex to just after the actual match (not consuming the next leading char)
    // so consecutive refs in same text are detected.
    REFERENCE_REGEX.lastIndex = end;
  }
  return results;
};

/**
 * Construye el link a YouVersion (bible.com) para una referencia USFM.
 * @param usfm  Ej: "JHN.3.16" o "JHN.3.16-JHN.3.18" o "JHN.3"
 * @param versionId  ID de Biblia en YouVersion (default 147 = Reina Valera Antigua español)
 * @param versionAbbr Abreviatura para el slug (default RVES)
 */
export const buildYouVersionLink = (usfm, versionId = 147, versionAbbr = 'RVES') => {
  // bible.com format: https://www.bible.com/bible/{version_id}/{USFM}.{abbreviation}
  // For ranges, only the first ref needs the abbreviation suffix.
  const firstPart = usfm.split('-')[0];
  const rest = usfm.includes('-') ? '-' + usfm.split('-').slice(1).join('-') : '';
  return `https://www.bible.com/bible/${versionId}/${firstPart}.${versionAbbr}${rest}`;
};

/**
 * Parte un texto en pedazos: strings comunes + objetos {bibleRef: {...}}.
 * Útil para renderizar inline con React.
 */
export const splitTextWithReferences = (text) => {
  const refs = findBibleReferences(text);
  if (!refs.length) return [{ type: 'text', value: text }];
  const out = [];
  let cursor = 0;
  for (const r of refs) {
    if (r.start > cursor) out.push({ type: 'text', value: text.slice(cursor, r.start) });
    out.push({ type: 'ref', value: r.match, ref: r });
    cursor = r.end;
  }
  if (cursor < text.length) out.push({ type: 'text', value: text.slice(cursor) });
  return out;
};
